import * as THREE from "three"
import React, {
  Suspense,
  useRef,
  useEffect,
  useState,
  useCallback,
} from "react"
import { Canvas, useThree } from "react-three-fiber"
// import { useInView } from "react-intersection-observer"
import SelfModel from "./selfModel"
import { getMousePos } from "../../utils"
import { GroundTexture } from "./GroundTexture"
import { useContext } from "react"
import { ThemeContext } from "../layout"
import { GlobalContext } from "../../pages"
// import { Particles } from "./Particles"

function CanvasContent({ mouse, onLoad, showModel, theme }) {
  const [, forceUpdate] = useState()
  const { scene } = useThree()

  useEffect(() => {
    scene.background = new THREE.Color(theme === "light" ? 0xffffff : 0x000000) // 282c35)
    forceUpdate(true)
  }, [theme])

  const point = new THREE.PointLight(0xffffff, 1, 10, 2)
  point.position.y = 2
  point.position.z = 2
  point.position.x = 2.5
  point.rotation.x = Math.PI / 8
  return (
    <>
      <ambientLight intensity={0.1} />

      {/* <directionalLight color={0xccddff} intensity={0.8} position={[0, 0, 5]} /> */}
      {/* <pointLight
      decay={2}
      intensity={0.1}
      position={[0, 10, 10]}
      // distance={200}
    /> */}
      <primitive object={point} />
      {/* <pointLightHelper args={[point]} /> */}
      <hemisphereLight
        args={[0xffffff, 0xffffff, 0.61]}
        position={[0, 50, 0]}
      />
      <Suspense fallback={null}>
        <GroundTexture onLoad={onLoad} />
        {/* <Tetrahedron /> */}
        <SelfModel mouse={mouse} onLoad={onLoad} showModel={showModel} />
        {/* <Particles numOfParticles={25} /> */}
      </Suspense>
    </>
  )
}

function Background3D({
  updateStatus,
  backgroundStatus,
  showModel,
  // width: propWidth,
  // height: propHeight,
}) {
  const mouse = useRef({ x: undefined, y: undefined })
  const [objectsToLoad, updateLoadedObjects] = useState(["ground", "model"])
  const objsToLoad = useRef(objectsToLoad)
  const theme = useContext(ThemeContext)
  const { updateModelData } = useContext(GlobalContext)

  useEffect(() => {
    objsToLoad.current = objectsToLoad
  }, [objectsToLoad])

  const onLoad = useCallback(
    (id, modelData) => {
      if (objsToLoad.current.length) {
        const filteredLoadList = objsToLoad.current.filter(
          objectId => objectId !== id
        )
        if (id === "model") {
          updateModelData(modelData)
        }
        if (!filteredLoadList.length) {
          updateStatus(prevStatus => ({
            ...prevStatus,
            status: "success",
            itemsLoaded: prevStatus.itemsLoaded + 1,
          }))
        } else {
          updateStatus(prevStatus => ({
            ...prevStatus,
            itemsLoaded: prevStatus.itemsLoaded + 1,
          }))
        }
        updateLoadedObjects(filteredLoadList)
      }
    },
    [updateStatus]
  )

  return (
    <div
      className={`canvas-container
      ${backgroundStatus.status === "success" ? "" : "hidden"}`}
      // style={{
      //   width: window.innerWidth, // dims.width, // Math.max(350, dims.width * intersectionRatio),
      //   height: window.innerHeight, // propHeight,
      // }}
    >
      <Canvas
        className="main-canvas"
        gl={{
          alpha: false,
        }}
        camera={{
          fov: 80,
          // aspect: window.innerWidth / window.innerHeight, // dims.width / dims.height
          near: 0.1,
          far: 1000,
          position: [0, 0, 5],
        }}
        onMouseMove={e => (mouse.current = getMousePos(e))}
      >
        <CanvasContent
          mouse={mouse}
          onLoad={onLoad}
          showModel={showModel}
          theme={theme}
        />
      </Canvas>
    </div>
  )
}

export default Background3D
